import React, { useState, useEffect, useContext } from 'react'
import './login.css'
import { UserContext } from '../context/UserContext'

const Login = () => {
    const { login, loading, errorMessage } = useContext(UserContext)

    const [inputText, setInputText] = useState({
        username:'', password:''
    })
    
    const { username, password } = inputText

    const InputEvent = e => {
        const {name, value} = e.target
        setInputText({
            ...inputText,
            [name]:value
        })
    }

    const submitEvent = async (e) => {
        e.preventDefault()
        const data = {username, password}
        try {
            let response = await login(data)
            if (!response) return
            window.location.href = '/dashboard'
        } catch (error) {
            console.log(error)
        }        
    }

    useEffect(() => {
        document.title = 'Login | Durga College Admin panel';
    }, [])

  return (
    <div className="login-box">
        <h1>Sign In</h1>
        {
            errorMessage ? <div id="error">{errorMessage}</div> : ''
        }
        <form method="post" autoComplete="off" onSubmit={submitEvent} >
            <p>
                <label htmlFor="username"> Username : </label>
                <input 
                    type="text" 
                    name="username" 
                    value={inputText.username}
                    onChange={InputEvent}
                />
            </p>

            <p>
                <label htmlFor="password"> Password : </label>
                <input 
                    type="password" 
                    name="password" 
                    value={inputText.password}
                    onChange={InputEvent} 
                />
            </p>
            <p className="remember-me"> 
                <input type="checkbox" name="remember_me" id="remember_me" /> 
                <label htmlFor="remember_me">Remember me</label>
            </p>

            <p className="loginbtn">               
                <input type="submit" value= {loading ? 'Validate...' : 'Login'} />
            </p>
        </form>
    </div>
  )
}

export default Login;
